const ID = 'stepper';

export default ID;
